import { render, staticRenderFns } from "./IconPlafond.vue?vue&type=template&id=d22785c0&scoped=true"
import script from "./IconPlafond.vue?vue&type=script&lang=ts"
export * from "./IconPlafond.vue?vue&type=script&lang=ts"
import style0 from "./IconPlafond.vue?vue&type=style&index=0&id=d22785c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22785c0",
  null
  
)

export default component.exports